import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import { useStores } from '../../store/rootStore';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { GoalType } from '../../store/goalsStore';
import { trackOnboardingCollectedGoals } from '../../utils/analytics';

const CollectGoals = observer(() => {
  const { goalStore, getNextPagePath } = useStores();
  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedGoals(Array.from(goalStore.selectedGoals));
    navigate(getNextPagePath('CollectGoals'));
  };

  const handleClick = (selectedGoal: GoalType) => {
    goalStore.toggleGoal(selectedGoal);
  };

  return (
    <Container>
      <ProgressBar currentPage="CollectGoals" />
      <PageHeader title="Choose your goals"></PageHeader>
      <Flex direction={'column'}>
        {goalStore.goalOptions.map((option, idx) => (
          <RegularButton
            key={idx}
            title={option.title}
            image={option.image}
            onClick={() => handleClick(option.value)}
            isSelected={goalStore.selectedGoals.has(option.value)}
          />
        ))}
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={goalStore.selectedGoals.size < 1}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectGoals;
